import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import CertificationCard from "./CertificationCards";
import Particle from "../Particle";

import uxDesign from "../../Assets/Certifications/certificate_ux_design_1769193958004.png";
import dataViz from "../../Assets/Certifications/certificate_data_visualization_1769193974822.png";
import webDev from "../../Assets/Certifications/certificate_web_dev_1769193993221.png";
import genAI from "../../Assets/Certifications/certificate_genai_1769194024533.png";
import blockchain from "../../Assets/Certifications/certificate_blockchain_1769194044717.png";
import docker from "../../Assets/Certifications/certificate_docker_essentials_1769194061368.png";
import nptelSCM from "../../Assets/Certifications/certificate_nptel_scm_1769194094965.png";
import nptelGMM from "../../Assets/Certifications/certificate_nptel_gmm_1769194112969.png";

function Certifications() {
    return (
        <Container fluid className="project-section">
            <Particle />
            <Container>
                <h1 className="project-heading">
                    My <strong className="purple">Certifications </strong>
                </h1>
                <p style={{ color: "white" }}>
                    Here are the certifications I have achieved.
                </p>
                <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
                    <Col md={4} className="project-card">
                        <CertificationCard
                            imgPath={uxDesign}
                            title="Foundations of User Experience (UX) Design"
                            description="A comprehensive course on UX design principles, wireframing, and prototyping provided by Google."
                            link="https://www.coursera.org/account/accomplishments/verify/5PQMKXX3B2L9"
                        />
                    </Col>

                    <Col md={4} className="project-card">
                        <CertificationCard
                            imgPath={dataViz}
                            title="Tata Data Visualization"
                            description="Data visualization and storytelling certification from Tata, focusing on effective data presentation."
                            link="https://drive.google.com/file/d/1u4Q-QqpBmhsZLwU793IOXwlj8ir487ZX/view?usp=drive_link"
                        />
                    </Col>

                    <Col md={4} className="project-card">
                        <CertificationCard
                            imgPath={webDev}
                            title="HTML/CSS/JavaScript for Web Developers"
                            description="Deep dive into core web technologies, covering semantic HTML, CSS styling, and JavaScript programming."
                            link="https://www.coursera.org/account/accomplishments/verify/H2NY8H9R57BQ"
                        />
                    </Col>

                    <Col md={4} className="project-card">
                        <CertificationCard
                            imgPath={genAI}
                            title="GenAI: Generative Artificial Intelligence Fundamentals"
                            description="Foundational knowledge of Generative AI, its applications, and future potential."
                            link="https://drive.google.com/file/d/1sdefhEJVUwC0o53bApIPv9Bj7GVv0azQ/view?usp=drive_link"
                        />
                    </Col>

                    <Col md={4} className="project-card">
                        <CertificationCard
                            imgPath={blockchain}
                            title="BlockChain Technology"
                            description="Understanding the fundamentals of Blockchain technology and its applications in various industries."
                            link="https://drive.google.com/file/d/1pYlIE_f6fgzVmSfBYyLtJcYYYsjU7L8T/view?usp=drive_link"
                        />
                    </Col>

                    <Col md={4} className="project-card">
                        <CertificationCard
                            imgPath={docker}
                            title="Docker Essentials"
                            description="Essential skills for using Docker containers to develop, deploy, and run applications."
                            link="#"
                        />
                    </Col>

                    <Col md={4} className="project-card">
                        <CertificationCard
                            imgPath={nptelSCM}
                            title="NPTEL Supply Chain Management"
                            description="Certification in Supply Chain Management strategies and operations from NPTEL (Jan - April 2024)."
                            link="https://drive.google.com/file/d/1-V63K_kUnDrYpoqTrI-CExLnsRXfsxBn/view?usp=drive_link"
                        />
                    </Col>

                    <Col md={4} className="project-card">
                        <CertificationCard
                            imgPath={nptelGMM}
                            title="NPTEL Global Marketing Management"
                            description="Certification in Global Marketing Management concepts and practices from NPTEL (Jan - April 2025)."
                            link="https://drive.google.com/file/d/1D5YJm0bPDc7B24lzix7EBnZBupqEfcfL/view?usp=drive_link"
                        />
                    </Col>
                </Row>
            </Container>
        </Container>
    );
}

export default Certifications;
